import script from "./DiffAssetManagementPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiffAssetManagementPlan.vue?vue&type=script&setup=true&lang=ts"

import "./DiffAssetManagementPlan.vue?vue&type=style&index=0&id=3c9c7175&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9c7175"]])

export default __exports__